import { render, staticRenderFns } from "./Paso5.vue?vue&type=template&id=6273d52b&scoped=true&"
import script from "./Paso5.vue?vue&type=script&lang=js&"
export * from "./Paso5.vue?vue&type=script&lang=js&"
import style0 from "./Paso5.vue?vue&type=style&index=0&id=6273d52b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6273d52b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VCol,VRow,VSelect})
